import { SagaIterator } from 'redux-saga';
import { all, call } from 'redux-saga/effects';
import { SearchResult, SearchResultItem } from '@xiag-search/sdk';
import { GRID_SIZE } from 'src/constants/gridSize';
import { searchRequestSdk } from 'src/sagas/utils/requestSdk';
import { searchResolver } from 'src/sagas/searchResolver';
import { CustomFieldsMapping } from 'src/constants/customFieldsMapping';

export function* searchFetch(query: string): SagaIterator {
    const { total, items }: SearchResult = yield call(searchRequestSdk, { query, size: 1000, });

    return {
        total,
        data: items,
    };
}

export function* searchPrimaryResolve(items: SearchResultItem[]): SagaIterator {
    const gridItems = items.slice(0, GRID_SIZE);
    return yield all(gridItems.map((item) => call(searchResolver, item)));
}

export function extendCustomFieldsByDomains(
    items: SearchResultItem[],
    customFieldsMapping: CustomFieldsMapping): SearchResultItem[] {

    const domains = Object.keys(customFieldsMapping);
    return items.map((item) => {
        try {
            const url = new URL(item.url);
            if (domains.indexOf(url.host) !== -1) {
                return {
                    ...item,
                    ...{
                        customFields: {
                            ...item.customFields,
                            ...customFieldsMapping[url.host]
                        }
                    }
                };
            }
        } catch (e) {
            console.error(e);
        }
        return item;
    });
}

export function processItemsTitle(items: SearchResultItem[]): SearchResultItem[] {
    return items.map((item) => {
        const [title] = item.title.split('|');
        return {
            ...item, ...{ title: title.trim() },
        };

    });
}

export function* searchAdditionalResolve(items: SearchResultItem[]): SagaIterator {
    const filterdItems = items.filter((result) => {
        return result.customFields['exclude-result'] !== true;
    }).slice(GRID_SIZE);
    return yield all(filterdItems.map((item) => call(searchResolver, item)));
}
